export default "__VITE_PUBLIC_ASSET__03872cd6__"